<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createIssue') }}</h1>
      <div class="form-container">
        <IssueForm @save="save"></IssueForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import IssueForm from '@/components/IssueForm'

  export default {
    components: {
      DashboardLayout,
      IssueForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Issue/create', {
          issue: form,
          projectId: this.$route.params.projectId
        }).then(() => {
          this.$router.push({
            name: 'projectDetail',
            params: {
              projectId: this.$route.params.projectId,
              section: 'issues'
            }
          })
        })
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {
            name: 'projectDetail', path: {
              name: 'projectDetail',
              params: {projectId: this.$route.params.projectId}
            }
          },
          {name: 'createIssue'}
        ]
      }
    }
  }
</script>
